module.exports = __webpack_public_path__ + "img/approval-warning.799ed9c0.webp";